import axiosClient from './axiosClient';

const discussionApi = {
  get: (params) => {
    const url = '/discussions';
    return axiosClient.get(url, { params });
  },
  create: (data) => {
    const url = '/discussions';
    return axiosClient.post(url, data);
  },
  getById: (id) => {
    const url = `/discussions/${id}`;
    return axiosClient.get(url);
  },
  edit: (id, data) => {
    const url = `/discussions/${id}`;
    return axiosClient.put(url, data);
  },
  delete: (id) => {
    const url = `/discussions/${id}`;
    return axiosClient.delete(url);
  },
  getComment: (params) => {
    const url = '/discussions-comment';
    return axiosClient.get(url, { params });
  },
  createComment: (data) => {
    const url = '/discussions-comment';
    return axiosClient.post(url, data);
  },
  getSubComment: (id) => {
    const url = `/discussions-comment/${id}`;
    return axiosClient.get(url);
  },
  editComment: (id, data) => {
    const url = `/discussions-comment/${id}`;
    return axiosClient.put(url, data);
  },
  deleteComment: (id) => {
    const url = `/discussions-comment/${id}`;
    return axiosClient.delete(url);
  },
};

export default discussionApi;
